import {useLoaderData, useLocation, Navigate} from "react-router-dom";
import {useEffect} from "react";
import {getTemporaryToken} from "@/services/auth.service";

const Register = () => {
    const {state} = useLocation();
    // const {userId, userSecret} = state || {};
    const temporaryToken = getTemporaryToken();

    useEffect(() => {

    }, [])

    return (
        <>
            {(!!temporaryToken) ? (
                <Navigate to={'terms'} replace={true}  />
            ) : <Navigate to={'sign-up'} replace={true}  />}
        </>
    )
}

export default Register;